import {createSlatePlugin} from "platejs";
import {preserveAttributes} from "./base-plate-plugins";

export const DivPlugin = createSlatePlugin( {
    key: "div",
    node: {
        isElement: true,
        isContainer: true,
    },
    parsers: {
        html: {
            deserializer: {
                rules: [{
                    validNodeName: "DIV"
                }],
                attributeNames: preserveAttributes,
            }
        }
    }
})
